export default __webpack_public_path__ + "static/media/chat-bots-with-data.4a696d95.png";